import { render } from "./payment-method-item.vue?vue&type=template&id=3776ca66&ts=true"
import script from "./payment-method-item.ts?vue&type=script&lang=ts"
export * from "./payment-method-item.ts?vue&type=script&lang=ts"

import "./payment-method-item.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__